export default __webpack_public_path__ + "static/media/announcement2.ce6641b0.png";